import { AppSignature } from "src/app/models/app-signature";

export class StudentHealthAndNutritionModel extends AppSignature {
    studentID: string;
    height: number;
    weight: number;
    bmi: number;
    status: string;
    code: string;
    colorCode: String;
    mealsPerDay: number = 3;
    isVegetarian: boolean;
    hasAccessToDairyProtein: boolean;
}

export class BMIChartData {
    bmi: string;
    bmiZ: string;
    label: string;
    code: string;
    color: string;
    bg: string;
    icon: string;
    desc: string;
}
export class BMIChart {
    bmi_type: string;
    data: Array<BMIChartData>;
}

export class NutreitionChartData {
    data_type: string;
    data: FoodCategory[];
}

export class FoodCategory {
    food_type: string;
    food_list: FoodItem[];
}

export class FoodItem {
    icon: string;
    name: string;
    why: string;
    nutrient: string;
}